// File: app/(menu)/page.tsx
'use client'

import React from 'react'

function Home() {
  return (
    <div className="mainApp"><h1>Sponsor Coin 0x Home Page</h1></div>
  )
}

export default Home